export const requireRules = {
  required: 'This is required',
  validate: (value) => value.trim() !== '' || 'Field cannot contain only spaces',
};

export const emailValidationRules = {
  ...requireRules,
  validate: (value) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$/;
    if (value.trim() === '') {
      return 'Email cannot be empty or contain only spaces';
    }
    if (!emailRegex.test(value)) {
      return 'Invalid email address';
    }
    return true;
  },
};

export const websiteValidationRules = {
  validate: (url) => {
    if (!url) return true;
    const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
    return urlRegex.test(url);
  },
};

export const phoneValidationRules = {
  validate: (phone) => {
    if (!phone) return true;
    const strictPhoneRegex = /^\d{8,15}$/;
    // const phoneRegex = /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;
    return strictPhoneRegex.test(phone);
  },
};
